import type { AccountUser } from "../../lib/hooks/useAccountUsers";

interface UserSelectorProps {
  value: string | "other";
  availableUsers: AccountUser[];
  allAccountUsers: AccountUser[];
  selectedUserIds: (string | "other")[];
  index: number;
  onChange: (value: string | "other") => void;
  disabled?: boolean;
}

/**
 * Component for selecting a user from account users or entering a new participant
 */
export function UserSelector({
  value,
  availableUsers,
  allAccountUsers,
  selectedUserIds,
  index,
  onChange,
  disabled = false,
}: UserSelectorProps) {
  const showDropdown =
    allAccountUsers.length > 0 &&
    (availableUsers.length > 0 || selectedUserIds[index] !== "other");

  if (!showDropdown) {
    return null;
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Who is participating?
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as string | "other")}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
        disabled={disabled}
      >
        <option value="other">Someone else...</option>
        {allAccountUsers.map((u) => {
          // Filter out users already selected in OTHER rows
          const isAlreadySelected = selectedUserIds.some(
            (selectedId, i) => i !== index && selectedId === u.id,
          );

          if (isAlreadySelected && selectedUserIds[index] !== u.id) {
            return null;
          }

          return (
            <option key={u.id} value={u.id}>
              {u.firstName} {u.lastName} {u.isSelf ? "(Myself)" : ""}
            </option>
          );
        })}
      </select>
    </div>
  );
}

